import { IOrganismMenuItem } from '@belong/types';

export const getVisibleHeaderMenuItems = (
  isLoggedIn: boolean,
  isShopUiEnabled: boolean,
  headerMenuItems: IOrganismMenuItem[] = []
) => {
  return headerMenuItems.filter(menuItem => {
    if (!isShopUiEnabled) {
      // Shop URL must be updated if the Shop URL changes.
      return menuItem.url?.href !== '/new/shop';
    }

    // If the toggle is on, always show "ALL" visibility links
    if (menuItem.visibility === 'All') {
      return true;
    }

    // Filter based on authenticated visibility
    return isLoggedIn ? menuItem.visibility === 'Authenticated' : menuItem.visibility === 'Unauthenticated';
  });
};
